var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search_shop_inner" }, [
      _c("i", { staticClass: "el-icon el-icon-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }